module.exports = __webpack_public_path__ + "static/wells_fargo-merchant_services-9bb1847f6f4275dff7ee9094df5fe128.svg";